// GuestBanner.tsx — signed-out browsing notice. Shared by Home + post-detail.
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ConsolePanel } from '@/ui';

export interface GuestBannerProps {
  /** Override the banner copy. */
  message?: string;
}

const Wrap = styled(ConsolePanel)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  flex-wrap: wrap;
`;

const Text = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const PrimaryLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.font.body};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.xs};
  padding: 6px 14px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid transparent;
  text-decoration: none;
  /* An inline prompt that repeats down the feed. Secondary, so the one filled
     call to action on a signed-out screen stays the persistent bottom bar. */
  background: ${({ theme }) => theme.color.surface};
  color: ${({ theme }) => theme.color.textPrimary};
  border: 1px solid ${({ theme }) => theme.color.hairSoft};
  transition: transform 80ms ease, opacity 160ms ease;
  &:active { transform: translateY(1px); }
`;

const DEFAULT_MESSAGE = "You're browsing TruXSocial. Sign in to join the conversation.";

export function GuestBanner({ message = DEFAULT_MESSAGE }: GuestBannerProps) {
  return (
    <Wrap role="status" aria-label="Guest browsing notice">
      <Text>{message}</Text>
      <PrimaryLink to="/signin">Sign in</PrimaryLink>
    </Wrap>
  );
}
